import {combineReducers, configureStore, createDynamicMiddleware} from '@reduxjs/toolkit';

import * as slices from './slices';

const appReducer = combineReducers({
    ...slices,
});

export type RootState = ReturnType<typeof appReducer>;
export type AppDispatch = ReturnType<typeof configureAppStore>['dispatch'];

let dispatch: AppDispatch = import.meta.hot?.data?.dispatch;
let getState: () => RootState = import.meta.hot?.data?.getState;

const rootReducer: typeof appReducer = (state, action) => {
    return appReducer(state, action);
};

const dynamicMiddleware = createDynamicMiddleware();

const configureAppStore = (initialState = {}) => {
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(dynamicMiddleware.middleware),
        devTools: false,
        preloadedState: initialState,
    });

    dispatch = store.dispatch;
    getState = store.getState;

    if (import.meta.env.DEV && import.meta.hot) {
        import.meta.hot.data.dispatch = dispatch;
        import.meta.hot.data.getState = getState;
    }

    return store;
};

export {configureAppStore as configureStore, dispatch, getState};
